// extracted by mini-css-extract-plugin
export default {"container":"Modal-module--container--1VH7-","video":"Modal-module--video--lR-fS","button":"Modal-module--button--xu6uL","buttonClose":"Modal-module--buttonClose--FNbbN"};